export const benefits = [
  {
    icon: "/assets/benefits/shield-check.svg",
    title: "Company Profiles",
    description:
      "See bidder details, ratings, previous customer reviews, recent offers, and notes.",
  },
  {
    icon: "/assets/benefits/price-tag.svg",
    title: "Competitive Bidding",
    description:
      "Post your move and receive private bids from multiple movers. Pick the offer that fits your budget and timing.",
  },
  {
    icon: "/assets/benefits/trophy.svg",
    title: "You Choose the Winner",
    description:
      "Review offers, compare notes, and award the job to your preferred mover—no pressure.",
  },
  {
    icon: "/assets/benefits/truck.svg",
    title: "Helpful Support",
    description:
      "Have questions? Send us a message and we’ll reply during business hours.",
  },
];
